import { createAsyncThunk } from '@reduxjs/toolkit';
import { CategoryCake } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { CreatePatchCategoryCake, FindCategoryCake, GetCategoryCake } from './interface';

export const findCategoryCake = createAsyncThunk(
  'categoryCake/findCategoryCake',
  async (values: FindCategoryCake, { rejectWithValue }) => {
    try {
      const response = await CategoryCake.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createCategoryCake = createAsyncThunk(
  'categoryCake/createCategoryCake',
  async (values: CreatePatchCategoryCake, { rejectWithValue }) => {
    try {
      const response = await CategoryCake.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchCategoryCake = createAsyncThunk(
  'categoryCake/patchCategoryCake',
  async ({ id, ...values }: CreatePatchCategoryCake, { rejectWithValue }) => {
    try {
      const response = await CategoryCake.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getCategoryCake = createAsyncThunk(
  'categoryCake/getCategoryCake',
  async ({ id }: GetCategoryCake, { rejectWithValue }) => {
    try {
      const response = await CategoryCake.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);